// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TinymceController from "./tinymce_controller.js"
application.register("tinymce", TinymceController)

import ResetFormController from "./reset_form_controller.js"
application.register("reset-form", ResetFormController)

import ChatController from "./chat_controller.js"
application.register("chat", ChatController)

import RemoteModalController from "./remote_modal_controller.js"
application.register("remote-modal", RemoteModalController)

import NotificationModalController from "./notification_modal_controller.js"
application.register("notification-modal", NotificationModalController)

import CopyController from "./copy_controller.js"
application.register("copy", CopyController)

import FancyboxController from "./fancybox_controller.js"
application.register("fancybox", FancyboxController)
